module.exports = __webpack_public_path__ + "457b587b8e68f2c87fd27eb440a42022.jpg";